export default defineAppConfig({
  storyblok: {
    resolveRelations: [
      'BlockContentCard.story',
      'BlockContentSecondaryCard.story',
      'BlockResourceCard.resource',
      'Page.authors',
      'BlockSelfAssessment.assessment',
    ],
  },
})
